import { post } from "helpers/api_helper"
const loginWithEmailPassword = data => post(`${process.env.REACT_APP_SERVICE_BASE_URL}admin/login`, data)
const LoginService = {
    loginWithEmailPassword
}
export default LoginService